const Connect = require("react-redux").connect;
const ForgotPassword = require("../components/ForgotPassword");
const ResetAct = require("actions/reset-password");

const internals = {};

internals.connect = Connect(null, {
    onSubmit: ResetAct.requestPasswordReset
});

module.exports = internals.connect(ForgotPassword);



// WEBPACK FOOTER //
// ./src/routes/forgot-password/containers/ForgotPassword.js